// extracted by mini-css-extract-plugin
module.exports = {"title":"ProductHeader_title__2zLxP","mainImage":"ProductHeader_mainImage__KabBI","companyLogo":"ProductHeader_companyLogo__1B5V7","countryLink":"ProductHeader_countryLink__DeqB3"};